import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  Link,
  Theme,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  ListItemIcon,
  Menu,
  MenuItem,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
// import {
//   PlayCircleFilledWhiteIcon
// } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';
import './selections.css';

import { getAccountAction, useAccount, } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction, useStats } from '@ivymobi/orbit-core/business/stats';
import { Tenant } from '@ivymobi/orbit-core';


import _ from 'lodash';
import { filter, isUndefined, union, isEmpty, cloneDeep } from 'lodash';
import { Autoplay, Pagination, FreeMode } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { getFirstLevelIndustryCaseAction, getSecondLevelIndustryCaseAction, getSVSolutionAction, getThirdLevelIndustryAction } from '@ivymobi/orbit-core/business/productCenter';
import { DeviceType, InnerUserContext, WebSiteContext } from '../../orbit-context';
import Title from '../../components/views/title';
import { TabPanel } from '../../components';
import RichText from '../../components/richText/RichTextRenderer';
import { getTitleById } from '../mapping';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'row',
  },
  appcaseContainer: {
    height:'100%',
    display:'flex',
    flexDirection:'column'
  },
  appcasePages: {
    background:'white',
    display:'flex',
    flexDirection:'column',
    width:'100%',
    flexGrow:1,
    margin: '0 auto',
    "@media (min-width: 768px)": {
      marginTop: '20px',
    }, 
     "@media (max-width: 768px)": {
      marginTop: '0px',
     },
    // minWidth: '1200px',
  },
  appcasewbg: {
    // backgroundColor: '#fff',
    height: '600px',
    marginTop: '15px',
    borderRadius: '2px',
    userSelect: 'none',
  },
  swiperItem: {
    position: 'relative',
  },
  swiperImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  swiperCover: {
    width: '100%',
    height: '200px',
    position: 'absolute',
    bottom:' 0',
    backgroundColor: 'rgba(15, 15, 15, .6)',
    cursor: 'pointer',
  },
}));
const queryParse = (query)=>{
  query = query.substring(query.indexOf('?')+1);
  let array = query.split("&")
  let params = {};
  array.forEach(item => {
    let key = item.substring(0,item.indexOf('='));
    let value= decodeURIComponent(item.substring(item.indexOf('=')+1));
    params[key]= value;
  });
  return params;
}
export const SVSelectionsContainer = (props) => {
  let params = queryParse(location.search);

  const classes = useStyles();
  const history = useHistory();
  const deviceType = useContext(DeviceType);

  const dispatch = useDispatch();
  const { webInfo } = useContext(WebSiteContext);
  const { secondId, thirdId } = useParams<any>();
  const innerUser = useContext(InnerUserContext);
  const [loading, setLoading] = useState(false);
  const [firstLevelCase, setFirstLevelCase] = useState([]);
  const [secondLevelCase, setSecondLevelCase] = useState([]);
  const [thirdLevelCase, setThirdLevelCase] = useState([]);
  // 路由列表数组
  const [extraBreadcrumbs, setExtraBreadcrumbs] = useState([]);
  // 路由标签对象
  const [breadList, setBreadList] = useState([]);


  return (
    <div className={classes.appcaseContainer}>
      {deviceType==='computer'&&<Breadcrumbs style={{ height: '30px' }} separator=">" maxItems={8}>
        <Link
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={'/'+params.catalogType}
          component={RouteLink}
        >
          {(getTitleById(params.catalogType)+(getTitleById(params.catalogType)==='伺服'?'系统':""))??''} 
        </Link>
        <Link
          color='textPrimary'
          to={'/inv/selections?catalogType=inverter'}
          component={RouteLink}
        >
          产品选型
        </Link>
        {breadList.map((item) => {
          return item;
        })}
        {/* {extraBreadcrumbs.map((item, index) => {
          console.log('执行路由遍历'+ index);
          // const url = index
          return (<Link 
            key={index}
            color='textPrimary'
            to={item.url}
            component={RouteLink}
          >
            {item.name}
          </Link>);
        })} */}
      </Breadcrumbs>}
    <Box className={classes.appcasePages}>
    <iframe allowFullScreen   style={{width:'100%',height:'100%',borderWidth:"0px"}} src='https://lite-mitsubishielectric.yangben.cn/common/index.html'></iframe>
 
      </Box>
    </div>
  );
};

export default function SelectionsContainer(props) {
  return (<SVSelectionsContainer {...props} />);
}